import React from 'react';
import styled, { css } from 'styled-components';
import { handleSizesMediaQueryStyling } from 'helpers/mediaQueryStyling';
import type { ISplash } from './shared/types';

const sizeStyling = {
    md: css`
        width: 16px;
        height: 16px;
    `,
    xl: css`
        width: 32px;
        height: 32px;
    `
};

const Splash = styled.img<{ $size: ISplash['size'] }>`
    ${({ $size }) =>
        $size && (typeof $size === 'object' ? handleSizesMediaQueryStyling($size, sizeStyling) : sizeStyling[$size])}
`;

export default function PictogramSplash(splash: ISplash): JSX.Element {
    const { imageUrl, size = 'md' } = splash;

    return <Splash src={imageUrl} alt="" $size={size} />;
}
